import React from 'react';

import Typography from 'components/typography/typography';

const CertificatesInformationDialog: React.FC = () => {
  return (
    <div className="w-full flex flex-col">
      <Typography as="p" variant="body-medium" className="text-gray600">
        Mogelijk heb jij naast jouw diploma ook certificaten behaald. Deze
        kunnen je een bevoegdheid geven voor het werken met specifieke groepen
        of activiteiten in de Kinderopvang. Denk bijvoorbeeld aan een
        certificaat voor BHV, VVE, Taalvaardigheid en EHBO. Een certificaat kan
        de kans op opdrachten verruimen.
        <br />
        <br />
        Upload in dat geval een scan of foto van je certificaat(-caten) en geef
        aan tot wanneer deze geldig is/zijn.
        <br />
        Let erop dat scan of foto scherp en duidelijk leesbaar is.
      </Typography>
    </div>
  );
};

export default CertificatesInformationDialog;
